import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { MasterInfo } from 'types';

export const InfoEvent: React.FC<{
  visitName: string;
  available: number;
  capacity: number;
  isAvailable: boolean;
  master?: MasterInfo;
  registrationFinished: boolean;
}> = ({
  visitName,
  available,
  capacity,
  isAvailable,
  master,
  registrationFinished = false,
}) => {
  const percent =
    isAvailable && capacity ? Math.max((100 * available) / capacity, 10) : 0;
  const index = +(percent >= 70) + +(percent > 20);
  const color = ['#FFA38F', '#FFE790', '#CEEFDB'][index];
  const nameColor = isAvailable ? 'black' : 'disabledText';
  const textColor = isAvailable ? 'asphalt.8' : 'disabledText';
  const message = registrationFinished
    ? 'Онлайн-запись завершена 😔'
    : 'Места закончились 😔';

  return (
    <Box>
      <Text
        color={nameColor}
        textStyle="h4"
        fontSize="0.875rem"
        lineHeight="1.25rem"
        translate="no"
      >
        {visitName}
      </Text>
      {master && master.isShow !== false && (
        <Text
          color={textColor}
          textStyle="body2"
          fontSize="0.625rem"
          translate="no"
        >
          {master.name}
          {master.position && `, ${master.position}`}
        </Text>
      )}
      <Text
        color={textColor}
        textStyle="body1"
        fontSize="0.75rem"
        mt="2px"
        px={2}
        bg={`linear-gradient(to right, ${color} ${percent}%, #F0F1F2 0%)`}
        borderRadius="md"
        whiteSpace="nowrap"
        width="fit-content"
      >
        {isAvailable ? `Осталось мест: ${available} из ${capacity}` : message}
      </Text>
    </Box>
  );
};
